import React, { useEffect, useRef, useState } from "react";
import { Card, ListGroup, Modal } from "react-bootstrap";
import api from "../../api/config";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import "../../styles/Comunity.css";
import { createdAgo } from "../../utils/dateFormatter";

const CommunityComment = ({
  commentCount,
  id,
  setSelectedCommunity,
  selectedCommunity,
  handleShowLogin,
  updateCommentCount,
}) => {
  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [media, setMedia] = useState("");
  const [error, setError] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const myRef = useRef(null);

  let data = localStorage.getItem("data");
  data = JSON.parse(data);

  const fetchComments = async () => {
    if (!data?.jwt) {
      console.log("Please login first");
      handleShowLogin(true);
    } else {
      setSelectedCommunity(id);
      setShowComments(true);
      try {
        const response = await api.get(`/community-feed/get-comment/${id}`);
        console.log(response);
        setComments(response?.data?.response);
      } catch (error) {
        toast.error("Error fetching comments");
      }
    }
  };

  const handleCommentSubmit = async (e, postId) => {
    e.preventDefault();
    if (newComment === "" && !image) return;
    setLoading(true);
    const payload = {
      comment: newComment,
      communityFeedId: id,
    };
    const formData = new FormData();
    formData.append("data", JSON.stringify(payload));
    if (!!image) {
      formData.append("file", image);
    }
    try {
      const response = await api.post("/community-feed/add-comment", formData);
      if (response?.data?.status === 200) {
        updateCommentCount(postId);
        fetchComments(true);
        setNewComment("");
        setPreviewUrl(null);
        setImage(null);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
      setPreviewUrl(null);
    }
  };

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const validFileTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "video/mp4",
      "video/webm",
      "video/ogg",
    ];
    if (!validFileTypes.includes(selectedFile.type)) {
      setError(true);
      toast.error("Invalid file type. Only images/videos are allowed!");
      return;
    }
    setImage(selectedFile);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
      setError(false);
    }
  };

  useEffect(() => {
    if (myRef.current && comments?.length > 0) {
      myRef.current.scrollTop = 0; // Scroll to the top
    }
  }, [comments]);
  const overlayRef = useRef(null);
  useEffect(() => {
    if (showComments) {
      const handleClickOutside = (event) => {
        if (
          overlayRef.current &&
          !overlayRef.current.contains(event.target) &&
          //!event.target.closest(".fa-comment") &&
          !event.target.closest(".comentr") &&
          !event.target.closest(".comments-container")
        ) {
          setShowComments(false);
        }
      };

      document.addEventListener("click", handleClickOutside);

      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [showComments]);

  return (
    <>
      <div
        className="comentr"
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "baseline",
          marginLeft: "10px",
        }}
      >
        <button
          className="btn-comment custom-button-comment"
          style={{ marginRight: "5px", backgroundColor: "white" }}
          onClick={() => {
            fetchComments(true);
          }}
        >
          <i className="fa fa-comment" aria-hidden="true"></i>
          <span style={{ marginLeft: "5px" }}>
            {/* {commentCount === 0 ? "Comment" : `${commentCount} Comments`} */}
            {/* {`${commentCount} ${commentCount === 1 ? "Comment" : "Comments"}`} */}
            {commentCount === 0
              ? "Comment"
              : commentCount === 1
              ? "1 Comment"
              : `${commentCount} Comments`}
          </span>
        </button>
      </div>

      {id === selectedCommunity && showComments && (
        <>
          <div
            className="dropdown-menu show"
            ref={overlayRef}
            onClick={() => setShowComments(false)}
            style={{ zIndex: "1", right: "23%", marginTop: "50px" }}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <Card
                className="mt-4 comment-card"
                style={{ width: "50rem", height: "20rem" }}
              >
                <div
                  style={{
                    maxHeight: "185px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                  }}
                  ref={myRef}
                >
                  {!comments?.length ? (
                    <Card
                      className="no-comment-text"
                      style={{
                        width: "50rem",
                        height: "200px",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    
                    >
                      <p>No comments to show</p>
                    </Card>
                  ) : (
                    <>
                      {comments.map((comment) => (
                        <React.Fragment key={comment?.id}>
                          <ListGroup className="list-group-flush m-3 mb-0">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                              }}
                            >
                              <Card.Subtitle className="mb-0 text-muted">
                                {comment?.firstName} {comment?.lastName}
                              </Card.Subtitle>
                              <Card.Subtitle
                                style={{ fontWeight: "normal" }}
                                className="mb-0 text-muted"
                              >
                                {createdAgo(comment?.createdDate)}
                              </Card.Subtitle>
                            </div>
                            {!comment?.media?.includes("mp4") ? (
                              <Card.Img
                                src={comment?.media}
                                onClick={() => {
                                  setMedia(comment?.media);
                                  toggleModal();
                                }}
                                style={{ cursor: "pointer", maxWidth: "40%" }}
                              />
                            ) : (
                              <video
                                type="video/mp4"
                                src={comment?.media}
                                alt="commentMedia"
                                style={{ cursor: "pointer", maxWidth: "40%" }}
                                controls
                              />
                            )}
                            <Card.Text>{comment?.comment}</Card.Text>
                            <Card.Text></Card.Text>
                          </ListGroup>
                          <hr />
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </div>
                {previewUrl && (
                  <div style={{ width: "50%" }}>
                    {!previewUrl?.includes("video") ? (
                      <div>
                        <img
                          src={previewUrl}
                          alt="Preview"
                          style={{
                            maxWidth: "50%",
                            height: 112,
                            margin: "10px",
                          }}
                        />
                      </div>
                    ) : (
                      <video
                        type="video/mp4"
                        src={previewUrl}
                        alt="Preview"
                        style={{
                          maxWidth: "50%",
                          height: 112,
                          margin: "10px",
                        }}
                        controls
                      />
                    )}
                  </div>
                )}
                <form onSubmit={(e) => handleCommentSubmit(e, id)}>
                  <div className="m-2 d-flex align-items-center ">
                    <div className="input-group mt-5">
                      <input
                        maxLength={1000}
                        type="text"
                        className="form-control py-2"
                        placeholder="Write a comment..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <button
                        type="button"
                        className=""
                        onClick={handleFileUpload}
                        style={{
                          borderTopRightRadius: "0.375rem",
                          borderBottomRightRadius: "0.375rem",
                          backgroundColor: "#fff",
                          border: "1px solid #ced4da",
                        }}
                      >
                        <FontAwesomeIcon icon={faPaperclip} />
                      </button>
                    </div>
                    <input
                      accept="image/*,video/*"
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary ms-2 px-5 mt-5 py-2 w-25 comment-send-btn"
                      disabled={loading}
                      style={{ color: "#000" }}
                    >
                      {loading ? "Sending" : "Send"}
                    </button>
                  </div>
                </form>
              </Card>
            </div>
          </div>

          <Modal show={showModal} onHide={toggleModal}>
            <Modal.Body>
              {!media?.includes("mp4") ? (
                <img src={media} alt="Media" style={{ width: "100%" }} />
              ) : (
                <video
                  type="video/mp4"
                  src={media}
                  alt="Media"
                  style={{ width: "100%" }}
                  controls
                />
              )}
            </Modal.Body>
          </Modal>
        </>
      )}
      {/* <LoginModal show={showLoginModal} handleClose={handleClose} /> */}
    </>
  );
};

export default CommunityComment;
